import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Step5State {
  paymentRef: string;
  policyNo: string;
  riderPolicyNo: string;
  existingWhomToBuy?: string;
  isPaymentDone: boolean;
}

const initialState: Step5State = {
  paymentRef: "",
  policyNo: "",
  riderPolicyNo: "",
  existingWhomToBuy: "",
  isPaymentDone: false,
};

export enum PaymentStatus {
  SUCCESS = "processing",
  FAIL = "unsuccessful",
}

const step5Slice = createSlice({
  name: "SHIELD_STARTER_Step5",
  initialState,
  reducers: {
    updateReferenceNo: (
      state,
      action: PayloadAction<{
        paymentRef: string;
        policyNo: string;
        riderPolicyNo: string;
      }>
    ) => {
      state.paymentRef = action.payload.paymentRef;
      state.policyNo = action.payload.policyNo;
      state.riderPolicyNo = action.payload.riderPolicyNo;
    },
    updateToDefaultStateStep5: (state, action: PayloadAction<string>) => ({
      ...initialState,
    }),
    updateExistingWhomToBuy: (state, action: PayloadAction<string>) => {
      state.existingWhomToBuy = action.payload;
    },
    updatePaymentStatus: (state, action: PayloadAction<boolean>) => {
      state.isPaymentDone = action.payload;
    },
  },
  extraReducers: {},
});

export const {
  updateReferenceNo,
  updateToDefaultStateStep5,
  updateExistingWhomToBuy,
  updatePaymentStatus,
} = step5Slice.actions;

export default step5Slice.reducer;
